import { GET_VERSIONS } from '../actions';

export default function(state = {}, action) {
    // switch(action.type) {
    //     case GET_VERSIONS:
    //         return state;
    //     default:
            return state;
    // }
}